import { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "./AuthContext";
import { getAccessMe } from "../services/accessApi";
import { setCurrentRights } from "../config/accessRights";

/**
 * Права «Доступов» текущего пользователя для меню и страниц — правка №58 (Чат 5). [Claude] 2026-11-03
 * По умолчанию (без провайдера, в тестах) — права выключены, всё по роли ERP, как раньше.
 */
const AccessRightsContext = createContext({ loaded: true, on: false });

export function AccessRightsProvider({ children }) {
    const { user } = useAuth();
    const userKey = user ? String(user.erp_user_id || user.id || "") : "";
    const [state, setState] = useState({ loaded: !user, on: false });

    useEffect(() => {
        let active = true;
        if (!userKey) {
            setCurrentRights(null);
            setState({ loaded: true, on: false });
            return () => { active = false; };
        }
        setState((s) => ({ ...s, loaded: false }));
        getAccessMe()
            .then((me) => { if (active) setState({ loaded: true, on: setCurrentRights(me).on }); })
            .catch(() => { if (active) { setCurrentRights(null); setState({ loaded: true, on: false }); } });
        return () => { active = false; };
    }, [userKey]);

    return <AccessRightsContext.Provider value={state}>{children}</AccessRightsContext.Provider>;
}

export function useAccessRights() {
    return useContext(AccessRightsContext);
}
